
import React, { useImperativeHandle, useState, forwardRef } from 'react';
import { Box, IconButton } from '@mui/material';
import ApexCharts from 'apexcharts';
import CustomIcon from '../../../Components/CustomIcon';


const ZoomResetView = forwardRef(({ chartID, containerStyles = {}, iconButtonStyles = {}, iconStyles = {}, onReset = () => {}, isZoomedProp = null }, ref) => {
    const [internalIsZoomed, setInternalIsZoomed] = useState(false);

    // Use prop if provided, otherwise use internal state
    const isZoomed = isZoomedProp !== null ? isZoomedProp : internalIsZoomed;

    const resetZoom = () => {
        if (Array.isArray(chartID)) {
            chartID.forEach((id) => {
                const chart = ApexCharts.getChartByID(id);
                chart.resetSeries(true, true);
            })
        } else {
            ApexCharts.exec(chartID, 'resetSeries')
        }

        setInternalIsZoomed(false);
        onReset?.();
    }

    // Expose methods to parent
    useImperativeHandle(ref, () => ({
        show: () => setInternalIsZoomed(true),
        reset: () => setInternalIsZoomed(false),
    }));

    if (!isZoomed) return null;

    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginRight: '48px', ...containerStyles }}>
            <IconButton onClick={() => resetZoom()} sx={iconButtonStyles}>
                <CustomIcon fontSize="25px" name='refresh-arrow-icon' sx={iconStyles} />
            </IconButton>
        </Box>
    );
});

export default ZoomResetView;
